__turbopack_context__.v({
  "checkbox": "RatingRefinement-module-scss-module__-3JORG__checkbox",
  "count": "RatingRefinement-module-scss-module__-3JORG__count",
  "item": "RatingRefinement-module-scss-module__-3JORG__item",
  "label": "RatingRefinement-module-scss-module__-3JORG__label",
  "list": "RatingRefinement-module-scss-module__-3JORG__list",
  "root": "RatingRefinement-module-scss-module__-3JORG__root",
});
